import React from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";

import OrderEdit from '~/pages/OrderEdit';

export default function ModalEdit({
  order,
  showModal,
  activeModal
}) {
  const dispatch = useDispatch();
  const orderEditReducer = useSelector(state => state.orderEditReducer);

  return(
    <Modal
      show={showModal}
      onHide={() => {
        dispatch({ type: 'SET_ORDERS_EDIT', orders: orderEditReducer.orderChoosed.products });
        activeModal(false);
      }}
      className="modal-contrato"
      centered
    >
      <Modal.Body scrollable={true} style={{ 
        padding: "0rem 2.5rem", 
        borderRadius: 15 
      }}>
        <OrderEdit showModal={showModal} activeModal={activeModal} />
      </Modal.Body>
    </Modal>
  );
}